import keymirror from 'keymirror';

const headerBackgroundMoveDirections = keymirror({
  vertical: null,
  horizontal: null,
  none: null,
  any: null,
});

export default headerBackgroundMoveDirections;
